//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/CAM.js";
import "../no/TaggedObject.js";
let d=[[[0,"ConstantLowerLimit",1,0],[0,"ConstantUpperLimit",1,0],[0,"FeedRateRange",1,0],[0,"LengthInterval",1,0],[0,"NominalChipThickness",1,0],[0,"NominalDepthPerCut",1,0],[0,"NominalStepover",1,0],[0,"OptimizationMethod",1,0],[0,"OptimizeNonCuttingFeedRate",1,0],[0,"PercentLowerLimit",1,0],[0,"PercentUpperLimit",1,0]],[],[]];
SPLM.CAM.FeedsOptimizationData = class extends SPLM.TaggedObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.CAM.FeedsOptimizationData";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.CAM.FeedsOptimizationData.OptimizationMethods = Object.freeze({
    "MaterialRemovalRate" : "MaterialRemovalRate", "Force" : "Force", "Torque" : "Torque"});

SPLM.CAM.FeedsOptimizationData.FeedRateRangeType = Object.freeze({
    "Percent" : "Percent", "Constant" : "Constant"});

export default SPLM;